import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import DefaultImageSVG from '@plone/volto/components/manage/Blocks/Listing/default-image.svg';

interface ImageListingProps {
  item: object;
  size: string;
}

const ImageListing: React.FC<ImageListingProps> = (props) => {
  const { item, size = 'preview', ...attrs } = props;

  const image = () => {
    if (item?.['image_field']) {
      return flattenToAppURL(
        `${item['@id']}/@@images/${item?.['image_field']}/${size}`,
      );
    } else {
      if (item.preview_image) {
        return flattenToAppURL(`${item['@id']}/@@images/preview_image/${size}`);
      } else if (item.image) {
        if (item?.image?.download) {
          return flattenToAppURL(item.image.download);
        }
        if (
          item?.image?.scales?.preview &&
          !isEmpty(item?.image?.scales?.preview)
        ) {
          return flattenToAppURL(item.image.scales.preview.download);
        }
        return flattenToAppURL(`${item['@id']}/@@images/image/${size}`);
      } else {
        return flattenToAppURL(item['image']?.scales?.[size]?.download);
      }
    }
  };

  const cardImage = image();

  return cardImage ? (
    <img
      src={cardImage}
      className="group-hover-img"
      alt={item?.['description'] || item?.['title']}
      loading="lazy"
      {...attrs}
    />
  ) : (
    <img
      src={DefaultImageSVG}
      alt={item?.['description'] || item?.['title']}
      loading="lazy"
      {...attrs}
    />
  );
};

export default ImageListing;
